import React from "react"
import styles from "./styles"
import {
  FormControl,
  InputLabel,
  Typography,
  Select,
  MenuItem,
  FormHelperText
} from "@material-ui/core/"
import { withStyles } from "@material-ui/core/styles"

const ReusableFormControlSelect = ({
  classes,
  name,
  label,
  openFrom,
  formikProps,
  inputProps = {},
  inputLabelClass = "",
  inputClass = "",
  options
}) => {
  const { handleChange, handleBlur, touched, errors, values } = formikProps
  return (
    <FormControl error={errors[name] && touched[name]} className={inputClass}>
      <InputLabel htmlFor={name}>
        <Typography variant="h5" color="primary" className={inputLabelClass}>
          {label}
        </Typography>
      </InputLabel>
      <Select
        name={name}
        id={name}
        value={values[name] ? values[name] : ""}
        onChange={handleChange}
        onBlur={handleBlur}
        {...inputProps}
      >
        {options &&
          options.map((option, index) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText className={classes.errorContainer}>
        {touched[name] && errors[name]}
      </FormHelperText>
    </FormControl>
  )
}

export default withStyles(styles)(ReusableFormControlSelect)



// WEBPACK FOOTER //
// ./src/components/ReusableFormControlSelect/index.js